<template>
  <div class="comp-media-placeholder">
    <div class="media-container">
      <img
      src="data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs="
      class="real-media">
    </div>
  </div>
</template>

<script>
export default {
  name: 'comp-media-placeholder'
}
</script>

<style scoped>
.comp-media-placeholder {
  /* common */
  background-color: #fff;
  color: #333;
  /* size */
  width: 100%;
}

.comp-media-placeholder .media-container {
  /* common */
  background: hsla(0, 0%, 0%, 1);
  /* position */
  position: relative;
  /* size */
  width: 100%;
  padding-top: calc(100% / 16 * 9);
}
.comp-media-placeholder .media-container .real-media {
  /* common */
  color: #fff;
  opacity: 1;
  /* position */
  position: absolute;
  top: 0;
  left: 0;
  /* size */
  width: 100%;
  height: 100%;
  /* alignment */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/CompMediaPlaceholder.vue